import { usePrevious, useUpdateEffect } from 'react-use';

import { EmergencyNotificationDismissCommand } from '@dreryk/egabinet-emergency-notification-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { translationKeys } from '../translations';

import { useEmergencyNotification } from './useEmergencyNotification';
import { shouldDispatchDismiss } from './emergencyNotificationDismiss.utils';

export const EmergencyNotificationDismiss = (): null => {
   const { state, context } = useEmergencyNotification();
   const previousType = usePrevious(state.type);
   const previousNotificationId = usePrevious(context.notificationId);

   const { executeAsync: dismissEmergencyNotification } = useCqrsCommand<void, number>((notificationId) => {
      const command = new EmergencyNotificationDismissCommand();
      command.notificationId = notificationId;
      return command;
   });

   useUpdateEffect(() => {
      if (shouldDispatchDismiss(previousType, state.type, previousNotificationId)) {
         dismissEmergencyNotification(previousNotificationId).catch(() => {
            dispatchSnackbarNegativeEvent(translationKeys.sosFailedToCancel);
         });
      }
   }, [state.type]);

   return null;
};
